<template>
  <div class="columns">
    <div v-if="modalState">
      <ModalCreateOfYourSite @showModal="show($event)" />
    </div>
    <div ref="canvasContainer" class="column is-two-thirds">
      <canvas ref="canvas"></canvas>
    </div>
    <div class="steps-descriptions column is-one-thirds">
      <a ref="btnDownload"
        ><button class="button margin-bottom is-primary">
          <base-icon
            class="has-text-white"
            style="margin-right: 0.5em"
            width="24px"
            height="24px"
            name="painel/download"
          />
          Download
        </button>
      </a>
      <stepsOfEditionCanvas />
    </div>
  </div>
</template>

<script>
import { fabric } from 'fabric'
import Invites from '@/lib/api/Invites'
import dataCanvas from '@/lib/invites/layoutsData'
import stepsOfEditionCanvas from '@/components/Invites/StepsOfEditionCanvas'
import ModalCreateOfYourSite from '@/components/Invites/modalCreateSite'

export default {
  components: {
    stepsOfEditionCanvas,
    ModalCreateOfYourSite,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    infosWedding: {
      get() {
        return this.$store.state.invites.weddingInfos
      },
      set(payload) {
        this.$store.dispatch('setWeddingInfo', payload)
      },
    },

    modalState: {
      get() {
        return this.$store.state.invites.modalState
      },
      set(payload) {
        this.$store.dispatch('setOpenModal', payload)
      },
    },
  },

  data() {
    return {
      started: false,
    }
  },

  watch: {
    logonToken(payload) {
      if (payload && payload.token && !this.started) {
        !this.infosWedding.casamento_data
          ? this.getData(payload)
          : this.createCanvas()
      } else {
        this.createCanvas()
      }
    },
  },

  mounted() {
    if (this.logonToken && this.logonToken.token && !this.started) {
      !this.infosWedding.casamento_data
        ? this.getData(this.logonToken)
        : this.createCanvas()
    } else {
      this.createCanvas()
    }
  },

  methods: {
    async getData(token) {
      this.started = true
      const communicationData = new Invites(token)
      const response = await communicationData.getSaveTheDateInfo(
        token.token_payload.wed_id
      )
      const mySiteInfo = response.data
      if (mySiteInfo) this.infosWedding = mySiteInfo

      this.createCanvas()
    },

    formatedDate(date) {
      return date.split('/')
    },

    getModelLayout() {
      return this.$router.currentRoute.params.modelo
    },

    uppercaseText(text) {
      if (
        this.getModelLayout() === 'conchas-oceano' ||
        this.getModelLayout() === 'algas-marinhas' ||
        this.getModelLayout() === 'por-sol'
      ) {
        return text.toUpperCase()
      } else return text
    },

    createCanvas() {
      this.started = true
      var FontFaceObserver = require('fontfaceobserver')

      const model = dataCanvas.comunicado[this.getModelLayout()]
      const imageBackgroudLayout = require(`@/assets/img/invites/communication/${model.pathImage}`)

      // GET DATA OBJ TEXT OF CANVAS

      let infoOfLayout = {}
      infoOfLayout.title = this.uppercaseText('Queridos familiares e amigos,')

      infoOfLayout.names =
        !this.infosWedding.noivo1_nome || !this.infosWedding.noivo2_nome
          ? this.uppercaseText('Romeo & Julieta')
          : this.uppercaseText(
              `${this.infosWedding.noivo1_nome} & ${this.infosWedding.noivo2_nome}`
            )

      infoOfLayout.urlSite = !this.infosWedding.site_url
        ? 'www.romeoejulieta.com'
        : this.infosWedding.site_url

      infoOfLayout.password = !this.infosWedding.site_senha
        ? ' '
        : `Senha: ${this.infosWedding.site_senha}`

      infoOfLayout.text = `Para que o nosso evento seja ainda melhor, é muito importante que você nos informe se poderá comparecer.\nPara isso, basta acessar o nosso site e navegar até a seção "confirmação de presença"\n\n${infoOfLayout.urlSite}\n${infoOfLayout.password}\n\nEsperamos por você! Com carinho,`

      // END GET DATA OBJ TEXT

      var fonts = [
        'Sacramento',
        'Dosis',
        'Dancing Script',
        'Euphoria Script',
        'Playfair Display SC',
        'Great Vibes',
        'Nunito',
        'Asap',
        'Baloo 2',
        'Oswald',
      ]
      var fontInstancia = []

      fonts.forEach((font) => {
        fontInstancia.push(new FontFaceObserver(font).load())
      })

      const widthCanvas = this.$refs.canvasContainer.clientWidth - 24
      const widthObjs = 500

      const ref = this.$refs.canvas
      const canvas = new fabric.Canvas(ref)

      canvas.setWidth(widthCanvas)
      canvas.setHeight(widthCanvas)
      ref.classList.add('canvas-border')

      fabric.Image.fromURL(imageBackgroudLayout, function (image) {
        image.set({
          selectable: false,
          scaleX: canvas.width / image.width,
          scaleY: canvas.height / image.height,
        })
        canvas.setBackgroundImage(image)
        canvas.renderAll()
      })

      var scaleWidthObj = canvas.width / canvas.width
      var scaleObj = Math.min(scaleWidthObj, scaleWidthObj)

      const width50Canvas = canvas.width / 2
      const marginTopCanvas = (canvas.height * 22) / 100
      Promise.all(fontInstancia)
        .then(function () {
          const textTitle = new fabric.Textbox(`${infoOfLayout.title}`, {
            fontFamily: model.textTitle.font,
            fontSize: model.textTitle.size,
            fill: model.textTitle.color,
            fontWeight: model.textTitle.weight,
            textAlign: model.textTitle.align,
            left: width50Canvas - widthObjs / 2,
            top: marginTopCanvas,
            width: widthObjs,
            scaleX: scaleObj,
            scaleY: scaleObj,
          })
          textTitle.lockRotation = true
          textTitle.hasRotatingPoint = false
          textTitle.lockUniScaling = true
          textTitle.objectCaching = false

          const textDescription = new fabric.Textbox(`${infoOfLayout.text}`, {
            fontFamily: model.textDescription.font,
            fontSize: model.textDescription.size,
            fill: model.textDescription.color,
            fontWeight: model.textDescription.weight,
            textAlign: model.textDescription.align,
            left: width50Canvas - widthObjs / 2,
            top: marginTopCanvas + model.textDescription.top,
            width: widthObjs,
            scaleX: scaleObj,
            scaleY: scaleObj,
          })
          textDescription.lockRotation = true
          textDescription.hasRotatingPoint = false
          textDescription.lockUniScaling = true
          textDescription.objectCaching = false

          const textName = new fabric.Textbox(`${infoOfLayout.names}`, {
            fontFamily: model.textName.font,
            fontSize: model.textName.size,
            fill: model.textName.color,
            fontWeight: model.textName.weight,
            textAlign: model.textName.align,
            lineHeight: 0.9,
            left: width50Canvas - widthObjs / 2,
            top: marginTopCanvas + model.textName.top,
            width: widthObjs,
            scaleX: scaleObj,
            scaleY: scaleObj,
          })
          textName.lockRotation = true
          textName.hasRotatingPoint = false
          textName.lockUniScaling = true
          textName.objectCaching = false

          canvas.add(textTitle)
          canvas.add(textDescription)
          canvas.add(textName)

          if (widthCanvas <= 500) {
            var SCALE_FACTOR = 0
            var TOP_ELEMENT = 0
            widthCanvas > 400 ? (SCALE_FACTOR = 0.65) : (SCALE_FACTOR = 0.56)
            widthCanvas <= 300
              ? ((SCALE_FACTOR = 0.5), (TOP_ELEMENT = 15))
              : (TOP_ELEMENT = 20)

            var objects = canvas.getObjects()
            for (var i in objects) {
              var scaleX = objects[i].scaleX
              var scaleY = objects[i].scaleY
              var top = objects[i].top

              var tempScaleX = scaleX * SCALE_FACTOR
              var tempScaleY = scaleY * SCALE_FACTOR
              var tempLeft = widthCanvas / 2 - (widthObjs * SCALE_FACTOR) / 2
              var tempTop = top * SCALE_FACTOR + TOP_ELEMENT

              objects[i].scaleX = tempScaleX
              objects[i].scaleY = tempScaleY
              objects[i].left = tempLeft
              objects[i].top = tempTop

              objects[i].setCoords()
            }
          }

          canvas.renderAll()
        })
        .catch(function (err) {
          console.warn('Some critical font are not available:', err)
        })

      let multiplierSizeImage = 2.8

      if (widthCanvas >= 451 && widthCanvas <= 600) {
        multiplierSizeImage = 2
      } else if (widthCanvas >= 601) {
        multiplierSizeImage = 1.4
      }

      const button = this.$refs.btnDownload
      button.addEventListener('click', () => {
        canvas.discardActiveObject().renderAll()
        if (!this.logonToken._result) {
          setTimeout(() => {
            this.modalState = true
          }, 800)
        }
        const hrefImage = canvas.toDataURL({
          format: 'png',
          quality: 1,
          multiplier: multiplierSizeImage,
        })

        this.$ga.event('Button', 'click', 'DownloadComunicadoSTD')

        const link = this.$refs.btnDownload

        if (navigator.userAgent.match(/iPhone/i)) {
          var image = new Image()
          image.src = hrefImage
          var w = window.open('')
          w.document.write(image.outerHTML)
        } else {
          link.href = hrefImage
          link.setAttribute('download', 'Comunicado-casarpontocom')
        }
      })
    },
  },
}
</script>

<style lang="scss">
.save-the-date-layout {
  &--button-download {
    margin-top: 64px;
  }

  &__description {
    margin-bottom: 32px;
  }
}
.canvas-border {
  border: solid 1px $gray-4;
}
</style>
